module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAD1JREFUeNpi5GlwYCAFMDGQCAahBhY0/tH02XoSKnDupRd3rGem4rMBWTUmd2iEEtCXeLhAwDgSkwZAgAEAWkUNubUjBb8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/stop2.png
// module id = 625
// module chunks = 1 6